<script setup>
    // Component
    import MainHeader from '@/components/HeaderComponent.vue';
    import medicalQuestionnarie from '@/components/modal/MedicalQuestionnarieComponent.vue';
    import suerveyApply from '@/components/modal/SuerveyApplyComponent.vue';
    import reserveCancelConfirm from '@/components/modal/ConfirmComponent.vue';
    import reserveCancelComplete from '@/components/modal/CompleteComponent.vue';
    import i18n from '@/common/i18n';

    import CounselorProfileComponent from '@/components/modal/CounselorProfileComponent.vue';
    import CounselingRoomGuidanceComponent from '@/components/modal/CounselingRoomGuidanceComponent.vue';

    // Store
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useReserveStore } from '@/stores/reserve/reserveStore';
    import { useLanguageStore } from '@/stores/common/languageStore';
    import { useLoginStore } from '@/stores/login/loginStore';

    // Vue
    import { onMounted, reactive, ref, inject } from 'vue';
    import { useRouter } from 'vue-router';
    import { getCurrentInstance } from 'vue';

    // Model
    import { ReserveDetailRequest } from '@/models/reserve/reserveModel';
    import utils from '@/commonProject/helpers/utils.js';

    // ----------------------------
    // 定数
    // ----------------------------
    const router = useRouter();
    const reserveStore = useReserveStore();
    const commonStore = useCommonStore();
    const languageStore = useLanguageStore();
    const loginStore = useLoginStore();
    const app = getCurrentInstance();
    const API_URL = app.appContext.config.globalProperties.$constProperties.BASE_API_URL_S;

    const counselorProfileModalDispFlg = ref('');
    const counselorProfileComponent = ref();

    const counselingRoomGuidanceModalDispFlg = ref('');
    const counselingRoomGuidanceComponent = ref();

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    // const message = ref('');
    // const cngMethodType = ref('');
    const reserveCancelConfirmDispFlg = ref('');
    const reserveCancelConfirmComponent = ref();
    const reserveCancelCompleteDispFlg = ref('');
    const reserveCancelCompleteComponent = ref();
    const medicalQuestionnarieDispFlg = ref('');
    const medicalQuestionnarieComponent = ref();
    const suerveyApplyDispFlg = ref('');
    const suerveyApplyComponent = ref();
    const reserveDetailRequest = reactive(new ReserveDetailRequest());
    const reserveCancelConfirmMessage = ref('');
    const paymentRefundFlag = ref(false);

    // メッセージダイアログ取得
    const { messageDialog } = inject('messageDialogKey');

    const requestData = reactive(reserveStore.rsvdtlRequest);
    // ----------------------------
    // API関数
    // ----------------------------

    /**
     * 予約取得APIを実行して、予約詳細画面を表示する。
     */
    async function getReserveDetailData() {
        // 予約取得APIのクエリパラメーターを生成する。
        reserveDetailRequest.value = {
            Lang: languageStore.getLanguageValue,
            ReservationPk: reserveStore.reservationPk,
        };

        // 予約取得APIをコールする。
        const response = await reserveStore.getDetailAction(API_URL, reserveDetailRequest.value);

        if (response.success) {
            // switch (reserveStore.reserveDetail.CngMethodType) {
            //     case '1':
            //         switch (reserveStore.reserveDetail.CngReserveType) {
            //             case '1':
            //                 cngMethodType.value = '予約場所:' + reserveStore.reserveDetail.RoomNm;
            //                 break;
            //             case '2':
            //                 if (roomType.value) {
            //                     cngMethodType.value = '予約場所:' + reserveStore.reserveDetail.RoomNm;
            //                 } else {
            //                     cngMethodType.value = '';
            //                 }
            //                 break;
            //             default:
            //                 cngMethodType.value = '';
            //                 break;
            //         }
            //         break;
            //     case '2':
            //         switch (reserveStore.reserveDetail.ServiceTelMet) {
            //             case '1':
            //                 message.value = 'カウンセリングの時間になりましたら以下の番号にお電話ください';
            //                 break;
            //             case '2':
            //                 message.value = 'カウンセリングの時間になりましたら以下の番号にお電話差し上げます';
            //                 break;
            //             default:
            //                 message.value = '';
            //                 break;
            //         }
            //         cngMethodType.value = '電話番号:' + reserveStore.reserveDetail.ServiceTelNum;
            //         break;
            //     case '3':
            //         message.value = 'カウンセリングのオンライン会議URL(Microsoft Teams)をご案内します';
            //         cngMethodType.value = 'URL:' + reserveStore.reserveDetail.OnlineUrl;
            //         break;
            //     default:
            //         message.value = '';
            //         break;
            // }

            // クレジットカード決済対象サービスの場合
            if (!utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId)) {
                if(reserveStore.reserveDetail.CanselOnTheDayFlag) {
                    // 当日キャンセル
                    switch(reserveStore.reserveDetail.PaymentRefundStatus) {
                        case "2":
                            // 返金区分が部分返金の場合
                            reserveCancelConfirmMessage.value = i18n.global.t('reserveCancelConfirm.parts.modalTitle3');
                            paymentRefundFlag.value = true;
                            break;
                        case "3":
                            // 返金区分が返金なしの場合
                            reserveCancelConfirmMessage.value = i18n.global.t('reserveCancelConfirm.parts.modalTitle2');
                            break;
                        default:
                            reserveCancelConfirmMessage.value = i18n.global.t('reserveCancelConfirm.parts.modalTitle1');
                    }
                } else {
                    // 事前キャンセル
                    reserveCancelConfirmMessage.value = i18n.global.t('reserveCancelConfirm.parts.modalTitle1');
                }
            } else {
                reserveCancelConfirmMessage.value = i18n.global.t('reserveCancelConfirm.parts.modalTitle1');
            }
            
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
            return;
        }
    }
    // ----------------------------
    // 関数
    // ----------------------------
    // 戻るボタン押下時
    function onBack() {
        // 遷移元画面をリセットする。
        commonStore.setFrom('');

        // 遷移元の画面に戻る。遷移元は予約一覧画面。
        // router.back();
        router.push({ name: 'reservelist' });
    }
    /**
     * 予約取消確認モーダル
     */
    function reserveCancelConfirmOpen() {
        reserveCancelConfirmDispFlg.value = 'block';
        reserveCancelConfirmComponent.value.openModal(API_URL, reserveStore.reservationPk);

        // let message = '';
        // if (utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId))
        // {
        //     message = '本予約は無料キャンセル期限を超過しているため、ご利用料金は返金されませんがよろしいですか？';
        // }

        // // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        // if (!utils.isNullEmpty(message)) {
        //     // エラーメッセージが存在する場合は、画面に表示する。
        //     messageDialog('unpaid', message);
        //     return true;
        // }

    }
    // 子コンポーネントで「はい」押下時
    function reserveCancelConfirmConfirm() {
        reserveCancelConfirmDispFlg.value = '';
        reserveCancelCompleteDispFlg.value = 'block';
    }
    // 子コンポーネントで「いいえ」押下時
    function reserveCancelConfirmClose() {
        reserveCancelConfirmDispFlg.value = '';
    }
    // 子コンポーネントで「閉じる」押下時
    function reserveCancelCompleteClose() {
        reserveCancelCompleteDispFlg.value = '';
        router.push('/reserve/list');
    }
    // 子コンポーネントで「はい」押下後、エラー時
    async function reserveCancelConfirmError() {
        reserveCancelConfirmDispFlg.value = '';
        await getReserveDetailData();
    }

    /**
     * 問診表モーダル
     */
    function medicalQuestionnarieOpen() {
        medicalQuestionnarieDispFlg.value = 'block';
        medicalQuestionnarieComponent.value.openModal(API_URL, reserveStore.reservationPk);
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function medicalQuestionnarieClose() {
        medicalQuestionnarieDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        // 画面をリフレッシュする。
    }
    // 予約を変更するボタン押下
    async function reserveEdit() {
        // 予約(予約詳細)画面から、予約を変更する場合は、事前に現予約情報を保持しておき、予約のカレンダータブ、もしくは、ご希望の場所・時間帯タブを復元する。

        // クエリパラメーターを生成。
        // 予約PKは、予約(予約詳細)画面から引き継いでいる、Storeに格納されている予約PKを利用する。
        const queryParam = {
            Lang: languageStore.getLanguageValue,
            ReservationPk: reserveStore.reservationPk,
        };

        // Storeを経由して、予約取得APIをコールする。
        const response = await reserveStore.getDetailAction(API_URL, queryParam);

        // エラーがある場合は、エラー処理を行い処理を終了する。
        if (response.success) {
            // 予約画面で復元する情報をStoreの変数に格納する。
            requestData.ServicePk = reserveStore.reserveDetail.ServicePk;
            requestData.SessionGrpPk = reserveStore.reserveDetail.SessionGrpPk;
            requestData.IssuePk1 = reserveStore.reserveDetail.IssuePk1;
            requestData.IssuePk2 = reserveStore.reserveDetail.IssuePk2;
            requestData.CngMethodType = reserveStore.reserveDetail.CngMethodType;
            requestData.CngLanguagePk = reserveStore.reserveDetail.CngLanguagePk;
            requestData.CngReserveType = reserveStore.reserveDetail.CngReserveType;
            requestData.RoomPk = reserveStore.reserveDetail.RoomPk;
            requestData.ReservationDt = reserveStore.reserveDetail.ReservationDt;
            requestData.CounselorPk = reserveStore.reserveDetail.CounselorPk;
            requestData.RegionPk = reserveStore.reserveDetail.RegionPk;
            requestData.AreaPk = reserveStore.reserveDetail.AreaPk;
            requestData.RequestDt1Start = reserveStore.reserveDetail.RequestDt1Start;
            requestData.RequestDt1End = reserveStore.reserveDetail.RequestDt1End;
            requestData.RequestDt2Start = reserveStore.reserveDetail.RequestDt2Start;
            requestData.RequestDt2End = reserveStore.reserveDetail.RequestDt2End;
            requestData.RequestDt3Start = reserveStore.reserveDetail.RequestDt3Start;
            requestData.RequestDt3End = reserveStore.reserveDetail.RequestDt3End;
            requestData.RequestNote = reserveStore.reserveDetail.RequestNote;

            // 予約(予約詳細)画面に遷移する。
            commonStore.setFrom('ReserveDetailView');
            router.push({ name: 'reserveplanningcounselor' });
        } else {
            messageDialog('error', response.errorMessage);
            if (response.redirect) {
                location.href = response.redirectUrl;
            }
        }
    }

    // ----------------------------
    // 算術プロパティ
    // ----------------------------
    // const roomType = computed(() => {
    //     return reserveStore.reserveDetail.CngMethodType === '1' && reserveStore.reserveDetail.CngReserveType === '2' && reserveStore.reserveDetail.RoomNm !== '';
    // });
    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        // 画面の初期表示を行う。
        // 別メソッドで予約取得APIを実行する。
        await getReserveDetailData();

        // 画面遷移元情報を取得
        const pageRouterParams = commonStore.from.split(':::::');

        // 画面遷移元情報を初期化する。
        commonStore.from = '';

        // 別画面の遷移先を判定する。
        switch (pageRouterParams[0]) {
            case 'NewsDetail':
                // ホーム画面のお知らせの「アンケートに回答」ボタンをクリックする。

                // 相談後アンケートモーダルを表示する。
                suerveyApplyOpen();

                break;
            default:
                // 何もしない。
                break;
        }

        let message = '';
        if ((reserveStore.reserveDetail.ReservationStatus === "1" || reserveStore.reserveDetail.ReservationStatus === "2") && reserveStore.reserveDetail.PaymentStatus === '1')
        {
            message = reserveStore.reserveDetail.PaymentExpireDt + i18n.global.t('common.message.creditUnpaid');
        }

        // エラーメッセージが存在する場合は、以降の処理に進ませないので、バリデーションチェック判定を返却する。
        if (!utils.isNullEmpty(message)) {
            // エラーメッセージが存在する場合は、画面に表示する。
            messageDialog('unpaid', message);
            return true;
        }

        return false;
    });

    /**
     * アンケート回答入力モーダル
     */
    function suerveyApplyOpen() {
        suerveyApplyDispFlg.value = 'block';
        suerveyApplyComponent.value.openModal(API_URL, languageStore.getLanguageValue, reserveStore.reservationPk, null, null);
        document.body.classList.add('modal-open'); //スクロール停止
    }
    function suerveyApplyClose() {
        suerveyApplyDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
        // 画面をリフレッシュする。
    }

    /**
     * カウンセラープロフィールモーダルを開くイベント処理
     */
    async function counselorProfileComponentOpen(CounselorPk) {
        counselorProfileComponent.value.openModal(API_URL, CounselorPk);
        counselorProfileModalDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }

    async function counselorProfileComponentClose() {
        counselorProfileModalDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }

    /**
     * ルーム・施設モーダルを開くイベント処理
     */
    async function counselingRoomGuidanceOpen(RoomPk) {
        if (utils.isNullEmpty(RoomPk)) {
            messageDialog('error', i18n.global.t('reservePlanningCounselor.parts.button1'));
            return;
        }
        counselingRoomGuidanceComponent.value.openModal(API_URL, RoomPk);
        counselingRoomGuidanceModalDispFlg.value = 'block';
        document.body.classList.add('modal-open'); //スクロール停止
    }

    async function counselingRoomGuidanceClose() {
        counselingRoomGuidanceModalDispFlg.value = '';
        document.body.classList.remove('modal-open'); //スクロール再開
    }

    /**
     * 問診票の登録が完了したので、予約詳細画面を再描画する。
     */
    async function updateReserveDetailFromMedicalQuestionnarie() {
        // 問診票画面を閉じる。
        medicalQuestionnarieDispFlg.value = '';

        // 別メソッドで予約取得APIを実行して、予約詳細画面を再描画する。
        await getReserveDetailData();

        // スクロール再開
        document.body.classList.remove('modal-open');
    }
    /**
     * アンケートの登録が完了したので、予約詳細画面を再描画する。
     */
    async function updateReserveDetailFromSuerveyApply() {
        // アンケート画面を閉じる。
        suerveyApplyDispFlg.value = '';

        // 別メソッドで予約取得APIを実行して、予約詳細画面を再描画する。
        await getReserveDetailData();

        // スクロール再開
        document.body.classList.remove('modal-open');
    }

    /**
     * 決済URL画面遷移
     */
    async function gmoOpen(LinkUrl) {
        if (LinkUrl != null && LinkUrl != '') {
                // reserveStore.reservationPk = response.reservationPk;
                window.location.href = LinkUrl;
                return;
            }
    }
</script>

<template>
    <section id="main">
        <section id="overlay" :style="{ display: reserveCancelConfirmDispFlg }">
            <!--予約取消確認モーダル-->
            <reserveCancelConfirm ref="reserveCancelConfirmComponent" @reserveCancelConfirmModal:cancel="reserveCancelConfirmClose" @reserveCancelConfirmModal:confirm="reserveCancelConfirmConfirm" @reserveCancelConfirmModal:error="reserveCancelConfirmError" :message="reserveCancelConfirmMessage" :paymentRefundFlag="paymentRefundFlag" />
        </section>
        <section id="overlay" :style="{ display: reserveCancelCompleteDispFlg }">
            <!--予約取消完了モーダル-->
            <reserveCancelComplete ref="reserveCancelCompleteComponent" :message="i18n.global.t('reserveCancelComplete.parts.modalTitle1')" @reserveCancelCompleteModal:close="reserveCancelCompleteClose" />
        </section>
        <section id="overlay" :style="{ display: medicalQuestionnarieDispFlg }">
            <!--問診表モーダル関連-->
            <medicalQuestionnarie ref="medicalQuestionnarieComponent" @medicalQuestionnarieModal:close="medicalQuestionnarieClose" @medicalQuestionnarieModal:update="updateReserveDetailFromMedicalQuestionnarie" />
        </section>

        <section id="overlay" :style="{ display: suerveyApplyDispFlg }">
            <!--アンケートモーダル関連-->
            <suerveyApply ref="suerveyApplyComponent" @suerveyApplyModal:close="suerveyApplyClose" @suerveyApplyModal:update="updateReserveDetailFromSuerveyApply" />
        </section>

        <section id="overlay" :style="{ display: counselorProfileModalDispFlg }">
            <!--カウンセリングプロフィールモーダル関連-->
            <CounselorProfileComponent ref="counselorProfileComponent" @counselorProfileModal:close="counselorProfileComponentClose" />
        </section>

        <section id="overlay" :style="{ display: counselingRoomGuidanceModalDispFlg }">
            <!--カウンセリングルーム案内モーダル関連-->
            <CounselingRoomGuidanceComponent ref="counselingRoomGuidanceComponent" @counselingRoomGuidanceModal:close="counselingRoomGuidanceClose" />
        </section>
        <MainHeader />
        <div id="contents">
            <div class="whiteBox">
                <h3 class="reserve">
                    <span>{{ $t('reserveDetail.parts.pageTitle1') }}</span>
                </h3>
                <section class="whiteBoxContents">
                    <ul class="btnArea whiteBox left">
                        <li style="margin-right: auto">
                            <template v-if="reserveStore.reserveDetail.ReservationStatus === '1'">
                                <!--受付-->
                                <label class="reserveStatus1">{{ commonStore.getConvertDictionary('ReservationStatus', reserveStore.reserveDetail.ReservationStatus, languageStore.getLanguageValue) }}</label>
                            </template>
                            <template v-if="reserveStore.reserveDetail.ReservationStatus === '2'">
                                <!--確定-->
                                <label class="reserveStatus2">{{ commonStore.getConvertDictionary('ReservationStatus', reserveStore.reserveDetail.ReservationStatus, languageStore.getLanguageValue) }}</label>
                            </template>
                            <template v-if="reserveStore.reserveDetail.ReservationStatus === '3'">
                                <!--キャンセル-->
                                <label class="reserveStatus3">{{ commonStore.getConvertDictionary('ReservationStatus', reserveStore.reserveDetail.ReservationStatus, languageStore.getLanguageValue) }}</label>
                            </template>
                            <template v-if="reserveStore.reserveDetail.ReservationStatus === '4'">
                                <!--当日キャンセル-->
                                <label class="reserveStatus4">{{ commonStore.getConvertDictionary('ReservationStatus', reserveStore.reserveDetail.ReservationStatus, languageStore.getLanguageValue) }}</label>
                            </template>
                        </li>
                        <li style="margin-right: 10px">
                            <button type="button" class="btnPrimary pc" id="reserveCancel" :disabled="!reserveStore.reserveDetail.AllowCancel" @click="reserveCancelConfirmOpen">{{ $t('reserveDetail.parts.button1') }}</button>
                            <button type="button" class="btnPrimary sp" id="reserveCancel" :disabled="!reserveStore.reserveDetail.AllowCancel" @click="reserveCancelConfirmOpen">{{ $t('reserveDetail.parts.button6') }}</button>
                        </li>
                        <li>
                            <button type="button" class="btnPrimary pc" id="reserveUpdate" :disabled="!reserveStore.reserveDetail.AllowChange" @click="reserveEdit">{{ $t('reserveDetail.parts.button2') }}</button>
                            <button type="button" class="btnPrimary sp" id="reserveUpdate" :disabled="!reserveStore.reserveDetail.AllowChange" @click="reserveEdit">{{ $t('reserveDetail.parts.button7') }}</button>
                        </li>
                    </ul>
                    <section class="form scroll">
                        <div class="formBox">
                            <!--予約情報-->
                            <h4>{{ $t('reserveDetail.parts.blockTitle1') }}</h4>
                            <dl class="line">
                                <!--ご予約日時-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl1') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span v-show="reserveStore.reserveDetail.ReservationDt">{{ reserveStore.reserveDetail.ReservationDt }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご利用方法-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl2') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd v-if="reserveStore.reserveDetail.CngMethodType === '1'">
                                    <ul class="formInput" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.RoomNm)">
                                        <li>
                                            <div class="noTextOverlow">{{ $t('reserveDetail.message.message1') + reserveStore.reserveDetail.RoomNm }}</div>
                                        </li>
                                        <li v-if="!utils.isNullEmpty(reserveStore.reserveDetail.RoomPk)">
                                            <!--ルーム・施設ボタン-->
                                            <button type="button" class="innerBtn" @click="counselingRoomGuidanceOpen(reserveStore.reserveDetail.RoomPk)">{{ $t('reserveDetail.parts.button4') }}</button>
                                        </li>
                                    </ul>
                                </dd>
                                <dd v-else-if="reserveStore.reserveDetail.CngMethodType === '2'">
                                    <ul class="formInput">
                                        <li v-if="reserveStore.reserveDetail.ServiceTelMet === '1'">
                                            <span class="noTextOverlow">{{ $t('reserveDetail.message.message2') }}</span>
                                            <div>{{ $t('reserveDetail.message.message4') + (utils.isNullEmpty(reserveStore.reserveDetail.ServiceTelNum) ? '' : reserveStore.reserveDetail.ServiceTelNum) }}</div>
                                        </li>
                                        <li v-else>
                                            <span class="noTextOverlow">{{ $t('reserveDetail.message.message3') }}</span>
                                            <div>{{ $t('reserveDetail.message.message4') + loginStore.phoneNumber }}</div>
                                        </li>
                                    </ul>
                                </dd>
                                <dd v-else-if="reserveStore.reserveDetail.CngMethodType === '3'">
                                    <ul class="formInput">
                                        <li>
                                            <span class="noTextOverlow">{{ $t('reserveDetail.message.message5') }}</span>
                                            <div style="word-break: break-all">
                                                {{ $t('reserveDetail.message.message6') }}
                                                <template v-if="!utils.isNullEmpty(reserveStore.reserveDetail.OnlineUrl)">
                                                    <a :href="reserveStore.reserveDetail.OnlineUrl" target="_blank">{{ reserveStore.reserveDetail.OnlineUrl }}</a>
                                                </template>
                                            </div>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px">
                                <!--カウンセラー-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl3') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.CounselorNm)">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.CounselorNm }}</span>
                                        </li>
                                        <li>
                                            <!--プロフィールボタン-->
                                            <button type="button" class="innerBtn" @click="counselorProfileComponentOpen(reserveStore.reserveDetail.CounselorPk)">{{ $t('reserveDetail.parts.button5') }}</button>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId)">
                                <!--決済オーダーID-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl17') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.PaymentOrderId }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId)">
                                <!--決済ステータス-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl18') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <template v-if="reserveStore.reserveDetail.PaymentStatus === '1'">
                                                <!--未決済-->
                                                <label>{{ commonStore.getConvertDictionary('PaymentStatus', reserveStore.reserveDetail.PaymentStatus, languageStore.getLanguageValue) }}</label>
                                            </template>
                                            <template v-if="reserveStore.reserveDetail.PaymentStatus === '2'">
                                                <!--決済完了-->
                                                <label>{{ commonStore.getConvertDictionary('PaymentStatus', reserveStore.reserveDetail.PaymentStatus, languageStore.getLanguageValue) }}</label>
                                            </template>
                                            <template v-if="reserveStore.reserveDetail.PaymentStatus === '3'">
                                                <!--キャンセル-->
                                                <label>{{ commonStore.getConvertDictionary('PaymentStatus', reserveStore.reserveDetail.PaymentStatus, languageStore.getLanguageValue) }}</label>
                                            </template>
                                            <template v-if="reserveStore.reserveDetail.PaymentStatus === '4'">
                                                <!--決済不要-->
                                                <label>{{ commonStore.getConvertDictionary('PaymentStatus', reserveStore.reserveDetail.PaymentStatus, languageStore.getLanguageValue) }}</label>
                                            </template>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId)">
                                <!--決済URL-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl19') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <div style="word-break: break-all">
                                                <a href="#" v-if="reserveStore.reserveDetail.PaymentStatus === '1'" @click.prevent="gmoOpen(reserveStore.reserveDetail.PaymentUrl)">{{ reserveStore.reserveDetail.PaymentUrl }}</a>
                                            </div>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px" v-if="!utils.isNullEmpty(reserveStore.reserveDetail.PaymentOrderId)">
                                <!--決済可能期限-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl20') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span v-if="reserveStore.reserveDetail.PaymentStatus === '1'">{{ reserveStore.reserveDetail.PaymentExpireDt }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                        <div class="formBox">
                            <!--予約詳細-->
                            <h4>{{ $t('reserveDetail.parts.blockTitle2') }}</h4>
                            <dl class="line">
                                <!--予約番号-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl4') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.ReservationNo }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--サービス-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl5') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.ServiceNm }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご相談内容1-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl6') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.IssueNm1 }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご相談内容2-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl7') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.IssueNm2 }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line" style="margin-bottom: 20px">
                                <!--ご利用言語-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl8') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.CngLanguageNm }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                        <div class="formBox" v-if="reserveStore.reserveDetail.CngReserveType === '2'">
                            <!--ご希望内容-->
                            <h4>{{ $t('reserveDetail.parts.blockTitle3') }}</h4>
                            <dl class="line">
                                <!--ご希望地域1-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl9') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.RegionNm }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご希望地区-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl10') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <span>{{ reserveStore.reserveDetail.AreaNm }}</span>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご希望日時1-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl11') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            {{ reserveStore.formattedTime(reserveStore.reserveDetail.RequestDt1Start, reserveStore.reserveDetail.RequestDt1End) }}
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご希望日時2-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl12') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            {{ reserveStore.formattedTime(reserveStore.reserveDetail.RequestDt2Start, reserveStore.reserveDetail.RequestDt2End) }}
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line">
                                <!--ご希望日時3-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl13') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            {{ reserveStore.formattedTime(reserveStore.reserveDetail.RequestDt3Start, reserveStore.reserveDetail.RequestDt3End) }}
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                            <dl class="line wrap" style="margin-bottom: 20px">
                                <!--ご連絡事項-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl14') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput">
                                        <li>
                                            <p>{{ reserveStore.reserveDetail.RequestNote }}</p>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                        <div class="formBox" style="padding-bottom: 7px" v-show="reserveStore.reserveDetail.InterviewStatus !== '0'">
                            <!--問診票の詳細情報-->
                            <dl style="margin-bottom: 20px; align-items: normal">
                                <!--相談前アンケート-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl15') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput" style="align-items: center; min-height: 40px">
                                        <li style="margin-right: auto">
                                            <span>{{ commonStore.getConvertDictionary('InterviewStatus', reserveStore.reserveDetail.InterviewStatus, languageStore.getLanguageValue) }}</span>
                                        </li>
                                        <li>
                                            <ul class="formInput">
                                                <li>
                                                    <!--相談前アンケートのモーダル表示ボタン-->
                                                    <button type="button" class="btnPrimary" style="width: 144px" v-show="reserveStore.reserveDetail.InterviewStatus === '1'" @click="medicalQuestionnarieOpen" :disabled="!reserveStore.reserveDetail.AllowAnswerIvw">{{ $t('reserveDetail.parts.button3') }}</button>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                        <div class="formBox" style="padding-bottom: 7px" v-show="reserveStore.reserveDetail.QuestionStatus !== '0'">
                            <!--アンケートの詳細情報-->
                            <dl style="margin-bottom: 20px; align-items: normal">
                                <!--相談後アンケート-->
                                <dt>
                                    <ul class="formLabel">
                                        <li>
                                            <label>{{ $t('reserveDetail.parts.dl16') }}</label>
                                        </li>
                                    </ul>
                                </dt>
                                <dd>
                                    <ul class="formInput" style="align-items: center; min-height: 40px">
                                        <li style="margin-right: auto">
                                            <span>{{ commonStore.getConvertDictionary('QuestionStatus', reserveStore.reserveDetail.QuestionStatus, languageStore.getLanguageValue) }}</span>
                                        </li>
                                        <li>
                                            <ul class="formInput">
                                                <li>
                                                    <!--相談後アンケートのモーダル表示ボタン-->
                                                    <button type="button" class="btnPrimary" style="width: 144px" v-show="reserveStore.reserveDetail.QuestionStatus === '1'" @click="suerveyApplyOpen" :disabled="!reserveStore.reserveDetail.AllowAnswerQue">{{ $t('reserveDetail.parts.button3') }}</button>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </dd>
                            </dl>
                        </div>
                    </section>
                </section>
                <section class="whiteBoxFooter">
                    <ul class="btnArea center">
                        <li>
                            <!--戻る-->
                            <button type="button" class="btnNormal" @click="onBack">{{ $t('common.parts.backPage') }}</button>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </section>
</template>

<style></style>
